import React from "react";

import Dashboard from "../@Components/Dashboard";
import { Col, Content, Grid, Row } from "rsuite";

import AffiliateList from "../@Components/Affiliates/AffiliateList";

const Affiliates: React.FC = () => {
  return (
    <Dashboard>
      {/*<PrimaryStatCards />*/}
      <Grid fluid>
        <Row className="show-grid">
          <Col className="content-card chart" xs={24}>
            <Content style={{ height: "fit-content" }}>
              <AffiliateList />
            </Content>
          </Col>
        </Row>
      </Grid>
    </Dashboard>
  );
};

export default Affiliates;
